module.exports = __webpack_public_path__ + "img/ico-success.d41d8cd9.svg";